
import { CardClassBranch } from '../../shared/components/card-class-branch/card-class-branch';
import InfiniteScroll from "react-infinite-scroll-component";
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { DataNotFound } from '../../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from '../constants/DataNotFound';
import { useLazyQuery } from '@apollo/client';
import { MODIFY_NAME_ZOOM } from '../../shared/graphql/branch';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { sendPageView } from '../../shared/services/analytics';

let classsesByBranch: any = [];

export default function ClassesBranchView({ dataInput, fetchMoreData, updateData, checkBooks, classIds, quotas, onEventAddClose,edit }: { dataInput: any, fetchMoreData: () => void, updateData: () => void, checkBooks: (element: any) => void, classIds: any[], quotas: any[], onEventAddClose: (result: any) => void, edit:boolean  }) {
    const location = useLocation();

    useEffect(() => {
        sendPageView(location.pathname + location.search, "Clases");
    }, [location]);

    const [getDog] = useLazyQuery(MODIFY_NAME_ZOOM);

    if (dataInput.data) {
        classsesByBranch = dataInput.data;
    }

    if (dataInput.error) {
        console.log(`Submission error! ${dataInput.error.message}`);
    }

    const OpenLink = (zoomResponseLink: any, flag: any) => {
        getDog({ variables: { zoomId: zoomResponseLink.id } });
        if (flag && zoomResponseLink.zoom_host_link) {
            window.open(zoomResponseLink.zoom_host_link, "_blank");
        } else {
            window.open(zoomResponseLink.zoom_link, "_blank");
        }
    }
    return (
        <>
            {(Object.entries(classsesByBranch).length === 0) && (
                <Grid item xs={12}>
                    <DataNotFound data={DATA_NOT_FOUND} />
                </Grid>
            )}
            {(Object.entries(classsesByBranch).length > 0) && (
                <InfiniteScroll
                    dataLength={classsesByBranch.length}
                    next={fetchMoreData}
                    hasMore={dataInput.has_more_pages || classsesByBranch.length < dataInput.total}
                    loader={
                        <p style={{ textAlign: 'center' }}>
                            <CircularProgress size={25} />
                        </p>}
                >
                    <Grid container>
                        {classsesByBranch.map((element: any, index: number) => (
                            <Grid item xs={12} md={12} key={index} >
                                <CardClassBranch zoomResponse={(e, flag) => OpenLink(e, flag)} cardData={element} checkBooks={() => checkBooks(element)} updateData={() => updateData()} edit={edit} />
                            </Grid>
                        ))}
                    </Grid>
                </InfiniteScroll>
            )}
        </>
    );
}